import { render } from "./ShareCallback.vue?vue&type=template&id=72caf2fc&scoped=true"
import script from "./ShareCallback.vue?vue&type=script&lang=js"
export * from "./ShareCallback.vue?vue&type=script&lang=js"

import "./ShareCallback.vue?vue&type=style&index=0&id=72caf2fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72caf2fc"]])

export default __exports__